import React, { ChangeEvent, ReactNode, SelectHTMLAttributes, useState } from 'react';

export interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  children: ReactNode[];
  id: string;
  label: string;
}

const Select = ({ children, className, id, label, value, onChange, ...rest }: Props): JSX.Element => {
  const [internalValue, setInternalValue] = useState<string | ReadonlyArray<string> | number>('');
  const controlled = value !== undefined;
  const currentValue = controlled ? value : internalValue;
  const hasValue = currentValue !== undefined && currentValue !== '';

  const handleChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    if (!controlled) setInternalValue(event.target.value);
    onChange?.(event);
  };

  return (
    <div className='relative'>
      <select
        id={id}
        className={`${className ?? ''} ${
          hasValue ? '' : 'text-transparent'
        } peer w-full mt-5 p-1 px-0.5 border-0 border-b-2 border-neutral-200 focus:border-sapphire focus:ring-0`}
        value={currentValue}
        onChange={handleChange}
        {...rest}
      >
        <option value='' disabled>
          {label}
        </option>
        {children}
      </select>
      <label
        className={`${
          hasValue ? 'top-0 text-neutral-700 text-sm' : 'top-6 text-neutral-400'
        } absolute left-0.5 peer-focus:top-0 peer-focus:text-sapphire peer-focus:text-sm pointer-events-none transition-all`}
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
};

export { Select };
